import { selectFromUserInviteCreatedDto } from '../models';
import { SubscriptionHandler } from '../utils/createSubscription';
import pendingInviteCreatedHandler from './handlers/account/pendingInviteCreatedHandler';
import MyPendingInviteQuery from '../queries/userInvite/MyPendingInviteQuery';

const selector = selectFromUserInviteCreatedDto()
  .userInvite(MyPendingInviteQuery)
  .toString();

export default (): SubscriptionHandler => ({
  name: 'MyPendingInvitesSubscription',
  selector,
  events: new Map(Object.entries({
    UserInviteCreatedDto: [pendingInviteCreatedHandler],
  })),
  onError(error: Error) {
    console.error('MyPendingInvitesSubscription Error, check if websocket client initialized', JSON.stringify(error));
  },
});

